import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { JwtService } from 'src/app/jwt.service';
import { ItemManager } from 'src/app/managers/item-manager';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';
import { ItemDetalhado } from 'src/app/persistences/item-detalhado';
import { ItemSimplesView } from 'src/app/persistences/item-simples-view';
import Item from 'src/app/persistences/item';
import { PesquisaService } from 'src/app/services/pesquisa.service';
import { ItemDetalhadoComponent } from '../item-detalhado/item-detalhado.component';
import { ListaSimilaresComponent } from '../lista-similares/lista-similares.component';

export interface IDialogSimilares {
  idItem: number;
  cdItem: string;
  /** Tabela de preço/unidade ativa no item de origem; o similar abre preservando-a (como no item detalhado). */
  cdTabelaPrecoAtiva?: number;
  unMedidaAtiva?: string;
  /** Padrão 'similares'; 'relacionados' reutiliza a mesma janela com os produtos relacionados. */
  tipo?: 'similares' | 'relacionados';
}

/**
 * Janela com a lista de itens similares (mesmo componente da sessão "Similares" do item detalhado).
 * Ao escolher um similar, ele é aberto no item detalhado; a lista permanece aberta por trás.
 */
@Component({
  standalone: false,
  selector: 'app-dialog-similares',
  templateUrl: './dialog-similares.component.html',
  styleUrls: ['./dialog-similares.component.css'],
})
export class DialogSimilaresComponent implements AfterViewInit {
  @ViewChild('listaSimilares') listaSimilares: ListaSimilaresComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDialogSimilares,
    public dialogRef: MatDialogRef<DialogSimilaresComponent>,
    private dialog: MatDialog,
    private pesquisaService: PesquisaService,
    private itemManager: ItemManager,
    private snackBarManager: SnackbarManager,
    private jwtService: JwtService
  ) {}

  ngAfterViewInit(): void {
    this.listaSimilares.carregaSimilares(this.data.idItem);
  }

  fechar(): void {
    this.dialogRef.close();
  }

  /** Carrega o similar escolhido (mesmo fluxo do item detalhado) e o abre no item detalhado. */
  abrirItemDetalhado(idItem: number): void {
    this.pesquisaService.carregaItensByIds([idItem]).subscribe(
      async (itens: Item[]) => {
        itens.forEach((item) =>
          this.itemManager.definirTabelaPrecoPreservada(item, undefined, this.data.cdTabelaPrecoAtiva, this.data.unMedidaAtiva)
        );

        const itensSimples: ItemSimplesView[] = this.itemManager.converterItensParaItensSimples(itens);
        const itemDetalhado: ItemDetalhado = itensSimples[0].itemDetalhado;
        itemDetalhado.itemPedido.quantidade = this.itemManager.getQuantidade(itemDetalhado.itemDetalhes.idItem);
        if (!itemDetalhado.itemPedido.quantidade || itemDetalhado.itemPedido.quantidade <= 0) {
          itemDetalhado.itemPedido.quantidade = this.itemManager.getMinimo(itemDetalhado).minimo;
        }
        await this.itemManager.getValor(itemDetalhado);

        const trilhaItens: Map<number, ItemDetalhado> = new Map();
        trilhaItens.set(idItem, new ItemDetalhado());
        this.dialog.open(ItemDetalhadoComponent, {
          width: '95%',
          maxWidth: '80vw',
          height: '95%',
          data: { trilhaItens, itemDetalhado, id: idItem },
        });
      },
      (error) => {
        this.jwtService.validarAcessToken(error);
        this.snackBarManager.openSnackBarErro(error, 'Não é possível consultar o item detalhado.', 'Ok', 3000);
      }
    );
  }
}
